import api from "../api-backend";

class OrganitzacioService {

    getOrganitzacions = async (page, size, query, sort) => {
        const response = await api.get(`/engine/organitzacions?query=${query}&rows=${size}&start=${page}&sort=${sort}`)
        return {
            'organitzacions': response.data.response.docs,
            'facetes': response.data.facet_counts.facet_fields,
            'total': response.data.response.numFound
        }
    }

    getOrganitzacio = async (id) => {
        const response = await api.get(`/engine/${id}`)
        return {
            'organitzacio': response.data.response.docs[0],
        }
    }
}

export default new OrganitzacioService()
